<template>
    <b-modal id="files-modal"
                ref="fileManagement"
                size="md"
                centered
                modal-class="modal-table modal-files"
                :no-close-on-backdrop="true"
                :no-close-on-esc="true"
    >
        <template #modal-header="{ close }">
            <div class="title">{{ getFmText('title') }}</div>
            <!-- <i class="icon icon-close" @click="close()"></i> -->
        </template>

        <template #modal-footer="{}">
            <b-button size="md" @click="onModalClose">
                {{ getFmText('cancel') }}
            </b-button>
            <b-button size="md" :disabled="!dataChanged" variant="success" @click="applyChanges">
                {{ getFmText('apply') }}
            </b-button>
            <b-button size="md" variant="outline-success" @click="downloadAttachedFiles" :disabled="downloadTracker.isDownloading">
                <file-download-ring v-if="downloadTracker.isDownloading" :progress="downloadTracker.progress" />
                {{ getFmText('download') }}
            </b-button>
        </template>



        <div class="modal-search">
            <b-form-group>
                <b-form-select v-model="selectedCategory" :options="categoryFiles" text-field="name"></b-form-select>
            </b-form-group>
            <b-form-group>
                <!-- Поле ввода текста для поиска -->
                <b-form-input ref="searchTextField" v-model="searchText" :placeholder="getFmText('search')" type="text"/>
                <!-- Кнопка очистки текста -->
                <i class="icon icon-close clear-button" @click="() => { searchText = '' }"/>
            </b-form-group>  
        </div>
        <b-tabs v-model="activeVersionTab" class="version-tabs">
            <b-tab :title="getLocText('current_version')"></b-tab>
            <b-tab :title="getLocText('past_versions')"></b-tab>
        </b-tabs>
        <div class="tab-content-panel">
            <div class="table-container modal-table-card">
                <p class="file-cat-name">{{ getFmText('attached') }}:</p>
                <p class="file-not-found" v-show="!searchedAttachedFiles.length">{{ getFmText('not_found') }}</p>

                <div class="file-info" v-for="item in searchedAttachedFiles" :key="item.id">
                    <div class="d-flex align-items-center">
                        <b-form-checkbox
                            v-model="item.row_id"
                            name="checkbox-1"
                            :value="item.id"
                            :unchecked-value="null"
                            :disabled="!variantAttribute"
                            @change="onFilesListChanged"
                        >
                        </b-form-checkbox>
                        <p class="name">
                            <file-icons :filename="item.file_name"></file-icons>
                            <span style="cursor: pointer" @click="()=>$emit('triggDownloadFile', item.file_name, item.id)">{{item.file_name}}</span>
                        </p>
                        <p class="size">({{getCatName(item.category)}})</p>
                        <p class="size">{{item['size']}}</p>
                    </div>
                </div>
            </div>
            <hr class="divider">
            <div class="table-container modal-table-card">
                <p class="file-cat-name">{{ getFmText('other') }}:</p>
                <p class="file-not-found" v-show="!searchedAllFiles.length">{{ getFmText('not_found') }}</p>

                <div class="file-info" v-for="item in searchedAllFiles" :key="item.id">
                    <div class="d-flex align-items-center">
                        <b-form-checkbox
                            v-model="item.row_id"
                            name="checkbox-1"
                            :value="item.id"
                            :unchecked-value="null"
                            :disabled="!variantAttribute"
                            @change="onFilesListChanged"
                        >
                        </b-form-checkbox>
                        <p class="name">
                            <file-icons :filename="item.file_name"></file-icons>
                            <span style="cursor: pointer" @click="()=>$emit('triggDownloadFile', item.file_name, item.id)">{{item['file_name']}}</span>
                        </p>
                        <p class="size">({{getCatName(item.category)}})</p>
                        <p class="size">{{item['size']}}</p>
                    </div>
                </div>
            </div>
            <b-button
                size="sm"
                variant="primary"
                style="margin: 1rem 0"
                @click="$emit('showFileUploadModal')"
                :disabled="!variantAttribute"
                v-if="activeVersionTab === 0"
            >
                {{ getFmText('upload') }}
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import FileUpdownMixin from '../mixins/file-updown-mixin';
import FileIcons from './file-icons.vue';
import FileDownloadRing from './file-download-ring.vue';

export default {
    name: "modal-files-management",
    components: { FileIcons, FileDownloadRing },
    props: {
        allFiles: Array,
        variantAttribute: Boolean,
    },
    mixins: [FileUpdownMixin],
    data() {
        return {
            selectedCategory: 'All',
            searchText: '',
            currItem: null,
            newFileCodes: null,
            dataChanged: false,
            newFileAdded: false,
            activeVersionTab: 0,
            downloadTracker: { progress: 0, isDownloading: false },
        }
    },
    watch: {
        allFiles: {
            deep: true,
            handler() {
                if (!this.attachedFiles) return;
                if (this.attachedFiles.some(f => f.new_file)) {
                    this.onFilesListChanged();
                }
            }
        }
    },
    methods: {
        async showModal(item) {            
            this.currItem = item;
            this.newFileCodes = item.file_hash;
            await this.loadDict();
            this.setAllCat();
            if (this.allFiles.length) {
                this.allFiles.forEach(item => {
                    if (item.new_file) {
                        this.$set(item, 'new_file', false);
                    }
                })
            }
            this.$refs.fileManagement.show();
        },

        getCatName(code) {
            const currCat = this.categoryFiles.find(item => item.value === code);
            return currCat ? currCat.name : null
        },

        onFilesListChanged() {
            const codes = this.attachedFiles
                .filter(item => item.row_id)
                .map(item => this.stringToUnicode(item.category + item.file_name))
                .join(';');
            this.newFileCodes = codes;
            this.dataChanged = true;
        },
        
        stringToUnicode(string) {
            let chr = '';
            if (string.length === 0) return hash;
            for (let i = 0; i < string.length; i++) {
                chr += string.charCodeAt(i);
            }
            return chr;
        },

        // точное совпадение кода файла среди кодов, перечисленных в file_hash через ';'.
        // Раньше здесь была проверка подстроки (String.includes без разбивки по разделителю) -
        // код одного файла может оказаться подстрокой кода другого, что давало ложные совпадения
        fileHashContainsCode(fileHash, rawString) {
            if (!fileHash) return false;
            return fileHash.split(';').includes(this.stringToUnicode(rawString));
        },

        onModalClose(e) {
            if (this.dataChanged) {
                if (e && e.preventDefault) e.preventDefault();
                this.onFilesModalClose();
            } else {
                this.currItem = null;
                this.dataChanged = false;
                this.$bvModal.hide('files-modal');
            }
        }, // отчистка 'goods-modal' при закрытии без сохранения

        onFilesModalClose() {
            this.$bvModal.msgBoxConfirm(
                this.getFmText('on_close'),
                {   
                    title: this.getFmText('attention'),
                    size: 'lg',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: this.getFmText('continue'),
                    cancelTitle: this.getFmText('cancel'),
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value) {
                        this.$bvModal.hide('files-modal')
                        this.currItem = null;
                        this.dataChanged = false;
                    } 
                })
                .catch(error => {
                    this.makeToast('danger', this.getFmText('error'), error.toString());
                });
        },

        applyChanges() {
            this.$emit('setNewFileHash', this.currItem.id, this.newFileCodes);
            this.dataChanged = false;
            this.$bvModal.hide('files-modal');
        },

        downloadAttachedFiles() {
            const fileNamesList = (this.attachedFiles || [])
                .filter(itm => itm.row_id)
                .map(itm => itm.file_name);
            if (fileNamesList.length) this.$emit('triggDownloadAllFiles', fileNamesList, this.downloadTracker);
            else this.makeToast('warning', this.getFmText('warning'), this.getFmText('no_files'));
        },

        makeToast(variant, title, tostbody) {
            this.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
                appendToast: true
            });
        },

        getFmText(field, extra = null) {
            const link = 'modules.budget_request.files_management.';
            return this.getText(link, field, extra)
        },
    },
    computed: {
        attachedFiles() {
            const newArr = this.allFiles.map(item => {
                if (this.currItem && this.fileHashContainsCode(this.currItem.file_hash, item.category + item.file_name)) {
                    item.row_id = item.id;
                } else if (item.new_file) {
                    item.row_id = item.id;
                } else item.row_id = null;
                return item;
            })
            return newArr
        },
        searchedAllFiles() {
            if (!this.attachedFiles) return [];
            const isCurrent = this.activeVersionTab === 0;
            const sortedFiles = this.attachedFiles.filter(item => {
                let result = true;
                if (this.selectedCategory !== "All") {
                    result = result && item.category === this.selectedCategory;
                };
                if (this.searchText.length) {
                    result = result && item.file_name.toLowerCase().includes(this.searchText.toLowerCase());
                };
                result = result && !item.row_id;
                result = result && (isCurrent ? item.is_current_version : !item.is_current_version);
                return result;
            });

            return sortedFiles.sort((a, b) => a.file_name > b.file_name ? 1 : -1);
        },
        searchedAttachedFiles() {
            if (!this.attachedFiles) return [];
            const isCurrent = this.activeVersionTab === 0;
            const sortedFiles = this.attachedFiles.filter(item => {
                let result = true;
                if (this.selectedCategory !== "All") {
                    result = result && item.category === this.selectedCategory;
                };
                if (this.searchText.length) {
                    result = result && item.file_name.toLowerCase().includes(this.searchText.toLowerCase());
                };
                result = result && item.row_id;
                result = result && (isCurrent ? item.is_current_version : !item.is_current_version);
                return result;
            });
            return sortedFiles.sort((a, b) => a.file_name > b.file_name ? 1 : -1);
        }
    },
}

</script>

<style scoped>
::v-deep .version-tabs .nav-tabs {
    position: static;
    border-top: none;
    margin-bottom: 0;
    width: 100%;
}
::v-deep .version-tabs .nav-tabs .nav-item {
    flex: 1;
    margin-left: 0;
    margin-right: 0;
}
::v-deep .version-tabs .nav-tabs .nav-item .nav-link {
    text-align: center;
}
::v-deep .version-tabs .nav-tabs .nav-item .nav-link.active {
    background-color: #F7F9FC;
}
.tab-content-panel {
    background-color: #F7F9FC;
    border-left: 1px solid #E2E5EB;
    border-right: 1px solid #E2E5EB;
    border-bottom: 1px solid #E2E5EB;
    padding: 0.5rem;
    margin-bottom: 1rem;
}
.divider {
    margin: 0.25rem 1rem;
    border-color: #E2E5EB;
}
.file-info {
    overflow: hidden;
    max-width: 100%;
    cursor: pointer;
    transition: background-color 0.15s;
}
.file-info:hover {
    background-color: #E9F4FD;
}
.file-info .d-flex {
    min-width: 0;
}
.file-info p {
    margin-bottom: 0;
    white-space: nowrap;
    flex-shrink: 0;
}
.file-info p.name {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-shrink: 1;
    padding-left: 0.5rem;
}
.file-info p.size {
    padding-right: 0.5rem;
}
.file-cat-name {
    font-size: 0.9rem;
    margin-bottom: 0.5rem;
    margin-top: 1rem;
}
.file-not-found {
    font-size: 0.8rem;
    font-style: italic;
    color: #A8B5CD;
    margin-left: 2rem;
}
::v-deep .modal-search .form-group {
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}
.serch-group {
    margin-top: 10px;
    display: flex;
}
.serch-group icon {
    position: absolute;
    right: 25px;
    margin-top: 5px;
}
</style>